import BasicResultModel from "../../domain/model/basic_result_model";
import AddonRepository from "../../domain/repository/addon_repository.js";
import { toAddonModel } from "../../domain/mapper/addon_result_mapper";

export default class AddonRepositoryImpl extends AddonRepository {
  static #instance = null;
  /**
   * Singleton constructor for AddonRepositoryImpl
   * @param {AddonAPIService} addonAPIService - The API service for add-ons
   * @param {AddonSocketServiceImpl} addonSocketService - The socket service for add-ons
   */
  constructor(addonAPIService, addonSocketService) {
    if (AddonRepositoryImpl.#instance) {
      // Update socket service if it's provided and different from current one
      if (addonSocketService && AddonRepositoryImpl.#instance.addonSocketService !== addonSocketService) {
        AddonRepositoryImpl.#instance.addonSocketService = addonSocketService;
      }
      return AddonRepositoryImpl.#instance;
    }

    /**
     * Call the parent constructor to set the API service
     * @param {AddonAPIService} addonAPIService - The API service for add-ons
     */
    super(addonAPIService);
    this.addonSocketService = addonSocketService;
    /**
     * Store the instance
     */
    AddonRepositoryImpl.#instance = this;
  }

  /**
   * Connects to the addon socket service
   */
  connectSocket() {
    if (!this.addonSocketService) {
      console.warn("Addon socket service not initialized");
      return;
    }
    this.addonSocketService.connect();
  }

  /**
   * Disconnects from the addon socket service
   */
  disconnectSocket() {
    if (!this.addonSocketService) {
      console.warn("Addon socket service not initialized");
      return;
    }
    this.addonSocketService.disconnect();
  }

  /**
   * Retrieves all active add-ons from the server
   * @returns {object} Server response data
   * @throws {object} Server error response
   */
  async getActiveAddons() {
    return await this.addOnApiService.getActiveAddons();
  }

  /**
   * Retrieves all add-ons from the server
   * @returns {object} Server response data
   * @throws {object} Server error response
   */
  async getAddons() {
    return await this.addOnApiService.getAddons();
  }

  /**
   * Avails an add-on for the user
   * @param {object} data - The data contains the add-on id and user id
   * @returns {BasicResultModel} - The result of the Avail Addon operation
   */
  async availAddon(data) {
    try {
      // Only emit socket event if socket service is initialized
      if (this.addonSocketService) {
        this.addonSocketService.emitAddonPurchase(data);
      }

      // Call the API service to avail add-on
      const result = await this.addOnApiService.availAddon(data);

      // Return the result in a BasicResultModel
      return new BasicResultModel(result.success, result.message, result.data);
    } catch (error) {
      console.error("Error in availAddon:", error);
      return new BasicResultModel(false, "Failed to purchase addon");
    }
  }

  /**
   * Check addon status
   * @param {string} addonId - The addon ID to check
   */
  checkAddonStatus(addonId) {
    if (!this.addonSocketService) {
      console.warn("Addon socket service not initialized");
      return;
    }
    this.addonSocketService.emitAddonStatusCheck(addonId);
  }

  async getAddonById(addOnId) {
    const result = await this.addOnApiService.getAddonById(addOnId);
    console.log("Addon Result", result);
    if (result.success) {
      return new BasicResultModel(result.success, result.message, [toAddonModel(result.data)]);
    }
    return new BasicResultModel(result.success, result.message);
  }
}
